// Copyright (c) 2019 Comsearch, Inc., All rights reserved

const changedFieldNames = fields => (
  Object.keys(fields).reduce((a, pathFieldName) => {
    // pathFieldName will be something like "path_id_234234"
    // since in values, this is an object,
    // in fields it will also be an object.
    const path = fields[pathFieldName]

    // builds a list of strings which point to specifically which
    // values were changed in the grid so that we only PUT what is necessary
    Object.keys(path).forEach(channelIndex => {
      if (path[channelIndex]?.touched === true) {
        a.push(`${pathFieldName}.${channelIndex}`)
      }
    })
    return a
  }, [])
)

export default changedFieldNames
